export default __webpack_public_path__ + "static/media/JobOne3.8b981112.JPG";